import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  list: {
    listStyleType: 'disc'
  },
  listPadding: {
    paddingLeft: theme.spacing(2)
  },
  listItem: {
    display: 'list-item'
  },
  listItemIcon: {
    margin: theme.spacing(0, 1.5, 0, 0),
    minWidth: 24
  },
  successIcon: {
    color: theme.palette.success.main
  },
  errorIcon: {
    color: theme.palette.error.main
  }
}));
